import { atom } from 'jotai';
import type { SplitOrderInvoicesSearchModel } from './split_order_invoices_search_types';
import { splitOrderInvoicesSearchStateVM } from './split_order_invoices_search_view_models';

export const splitOrderInvoicesSearchFormAtom = atom<SplitOrderInvoicesSearchModel>(splitOrderInvoicesSearchStateVM());
